import React from 'react'

import { cn } from '../ui/cn'

interface AltBlockProps {
  children: React.ReactNode
  className?: string
  innerClassName?: string
}

export const AltBlock = ({
  children,
  className,
  innerClassName,
}: AltBlockProps): React.ReactElement => {
  return (
    <div className={cn('snplay:bg-ui-decoratorLight snplay:py-24', className)}>
      <section className={cn('snplay-bounds', innerClassName)}>{children}</section>
    </div>
  )
}
